import {compose} from 'redux'

import {run} from 'permissions/panel/devices/walktest'

import {withPermission} from 'containers/withPermission'
import {withVisibility} from 'containers/withVisibility'
import withDevices from 'containers/withDevices'
import withProps from 'containers/withProps'

import Button from 'ipmp-react-ui/Button'
import Spinner from 'ipmp-react-ui/Spinner'

import {__} from 'utils/i18n'

export default compose(
    withPermission({isVisible: run}),
    withVisibility(),
    withDevices(),
    withProps(({stopWalktest, walktest: {isStopping}}) => ({
        onClick: stopWalktest,
        disabled: isStopping,
        Icon: isStopping ? Spinner : null,
        label: __('Stop Walktest'),
    })),
)(Button)